export default __webpack_public_path__ + "static/oven-1715d3ff9f837f4350630a5bab016be1.png";